import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clipboard"
export default class extends Controller {
	static targets = ["source", "label"];
	// The confirmation text is a value, not a string in here: it is user-facing
	// copy and belongs to pt-BR.yml with its en-US counterpart.
	static values = { copied: String, feedback: { type: Number, default: 2000 } };

	selectText() {
		const range = document.createRange();
		range.selectNodeContents(this.sourceTarget);

		const selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);
	}

	select() {
		if (this.sourceTarget.select) {
			this.sourceTarget.select();
		} else {
			this.selectText();
		}
	}

	copy() {
		this.select();
		const text = this.sourceTarget.value || this.sourceTarget.textContent.trim();
		if (navigator.clipboard?.writeText) {
			navigator.clipboard.writeText(text).then(
				() => this.confirm(),
				() => {},
			);
		} else {
			// Fallback for non-secure contexts (e.g. http dev hosts) where the async
			// Clipboard API is unavailable; select() already selected the text.
			if (document.execCommand("copy")) this.confirm();
		}
	}

	// The write itself is silent, and the selection it leaves behind is wiped by
	// anything that re-renders the panel — the Pix page reloads itself every 10s.
	// Without this the buyer taps Copiar on a phone and gets no answer at all.
	confirm() {
		if (!this.hasLabelTarget || !this.hasCopiedValue) return;

		this.originalLabel ??= this.labelTarget.textContent;
		this.labelTarget.textContent = this.copiedValue;
		clearTimeout(this.restoreTimer);
		this.restoreTimer = setTimeout(() => this.restore(), this.feedbackValue);
	}

	restore() {
		if (this.originalLabel === undefined) return;

		this.labelTarget.textContent = this.originalLabel;
	}

	disconnect() {
		clearTimeout(this.restoreTimer);
	}
}
